import styled from "styled-components";

// export const Container = styled.div`
//   @media screen and (max-width: 568px) {
//     .header {
//       flex-direction: column;
//       gap: 20px;
//       h3 {
//         font-size: 15px;
//         color: #1a237e;
//       }
//     }
//   }
//   .header {
//     display: flex;
//     justify-content: space-between;
//     .texts {
//       h3 {
//         font-size: 32px;
//         line-height: 44px;
//         color: #1a237e;
//       }
//       p {
//         margin-top: 5px;
//         line-height: 22px;
//         font-size: 16px;
//         color: #667085;
//       }
//     }

//     .link-buttons {
//       display: flex;
//       gap: 10px;
//       .see-more,
//       .add-campaign {
//         padding: 10px 16px;
//         height: 40px;
//         border: 1px solid #d0d5dd;
//         border-radius: 8px;
//         font-size: 14px;
//         background-color: transparent;
//         text-decoration: none;
//         cursor: pointer;
//         color: #344054;
//       }
//       .add-campaign {
//         color: #fff;
//         border: 1px solid #03a9f4;
//         background-color: #03a9f4;
//       }
//     }
//   }
// `;


export const Container = styled.div`
padding: 20px;
  background: linear-gradient(135deg, #f5f9fc 0%, #ffffff 100%);
  min-height: 100vh;
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h3 {
        font-size: 15px;
        color: #1a237e;
      }
    }
  }
  .header {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
        font-size: 32px;
        line-height: 44px;
        color: #1a237e;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }

  .form-group {
    margin-bottom: 1rem;

    label {
    margin-top: 20px;
    color: #344054;
    font-size: 14px;
  }

  input {
    width: 100%;
    //height: 43px;
    margin-top: 10px;
    border: solid 1px #e0e2e6;
    border-radius: 10px;
    padding: 12px 14px;
    transition: all 0.3s ease;

    &:focus {
      outline: #027f7f;
      border: 1px solid #03a9f4;
      background: transparent;
    }
  }

    /* label {
      display: block;
      margin-bottom: 0.5rem;
      font-weight: bold;
    }

    input {
      width: 100%;
      padding: 0.5rem;
      border: 1px solid #ccc;
      border-radius: 4px;
    } */
  }
  
  .submit {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .submit-buttons {
      display: flex;
      gap: 10px;
      .cancel,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }
`;

export const CardWrapper = styled.div`
margin-top: 30px;
  width: 100%;
  display: grid;
  gap: 20px;
  margin-bottom: 30px;
  //margin: auto;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 976px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
